<template>
<Toast />
<div class="row">
  <h2 class="titre">Authentification</h2>
</div>
<div class="row form-connexion align-items-center justify-content-center rounded">
  <vue-loaders v-show="loading" name="ball-beat"></vue-loaders>
  <div v-show="!loading" class="col-5">
    <div class="row">
      <div class="col"><InputText placeholder="Identifiant" id="identifiant" type="text" v-model="identifiant"/></div>
    </div>
    <div class="row">
      <div class="col"><InputText placeholder="Mot de passe" id="mdp" type="password" v-model="mdp"/></div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <div v-show="!loading">
          <Button label="Envoyer" v-on:click="authentifierUsager" />
          <Button label="Logon Usager" v-on:click="authentifierSuperUtilisateur" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Connexion",
  created() {
    this.MSG_ERREUR = "Votre accès a été refusé. Revérifiez vos informations de connexion."
    this.MSG_SUCCESS = "Votre accès a été authentifié. Redirection en cours..."
  },
  mounted() {
    this.$store.dispatch("cardex/initialiserAction")
  },
  data() {
    return {
      loading: false,
      identifiant: null,
      mdp: null,
    }
  },
  components: {},
  computed: {},
  methods: {
    toast(level, msg) {
        this.$toast.add({ severity: level, detail: msg, summary: 'Connexion', life: 6000 });
    },
    authentifierUsager() {
      this.loading = true
      this.$store.dispatch("cardex/connexionAction", {
        usager: this.identifiant,
        mdp: this.mdp
      })
      .then(() => {
        this.toast('success', this.MSG_SUCCESS)
        this.$router.push({ name: "choix-profil" })
        this.loading = false
      })
      .catch((error) => {
        console.log(error)
        this.loading = false
        this.toast('error', this.MSG_ERREUR)
      });
    },
    authentifierSuperUtilisateur() {
      this.loading = true
      this.$store.dispatch("cardex/connexionAction", {
        usager: process.env.VUE_APP_DASHBOARD_SUPERUSER_NOM,
        mdp: process.env.VUE_APP_DASHBOARD_SUPERUSER_MDP,
      })
      .then(() => {
        this.toast('success', this.MSG_SUCCESS)
        this.$router.push({ name: "choix-profil" })
        this.loading = false
      })
      .catch((error) => {
        console.log(error)
        this.loading = false
        this.toast('error', this.MSG_ERREUR)
      });
    },
  },
};
</script>
